import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGroups = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={8}
    fill="none"
    viewBox="0 0 16 8"
    {...props}
  >
    <path
      fill="currentColor"
      d="M.6 8a.58.58 0 0 1-.427-.173A.58.58 0 0 1 0 7.4v-.383q0-.85.75-1.334Q1.5 5.2 2.8 5.2a5 5 0 0 1 1 .1 2.5 2.5 0 0 0-.442.75 2.4 2.4 0 0 0-.158.843V8zm4 0a.58.58 0 0 1-.427-.173A.58.58 0 0 1 4 7.4v-.417q0-.464.242-.848a1.6 1.6 0 0 1 .641-.585q.735-.366 1.517-.558a6.74 6.74 0 0 1 3.2 0 7.2 7.2 0 0 1 1.517.558q.4.2.641.585.242.384.242.848V7.4a.58.58 0 0 1-.172.427A.58.58 0 0 1 11.4 8zm8.2 0V6.881q0-.447-.158-.848A2.6 2.6 0 0 0 12.2 5.3q.284-.05.525-.075T13.2 5.2q1.3 0 2.05.483.75.484.75 1.334V7.4a.58.58 0 0 1-.172.427A.58.58 0 0 1 15.4 8zM5.233 6.8h5.534q-.117-.284-.992-.542a6.24 6.24 0 0 0-3.55 0q-.875.259-.992.542M2.796 4.4q-.496 0-.846-.35a1.15 1.15 0 0 1-.35-.843q0-.507.35-.857A1.15 1.15 0 0 1 2.793 2q.507 0 .857.346t.35.858q0 .496-.346.846t-.858.35m10.4 0q-.496 0-.846-.35a1.15 1.15 0 0 1-.35-.843q0-.507.35-.857a1.15 1.15 0 0 1 .843-.35q.507 0 .857.346t.35.858q0 .496-.346.846t-.857.35M7.993 4a1.92 1.92 0 0 1-1.409-.583A1.93 1.93 0 0 1 6 2q0-.834.583-1.417A1.93 1.93 0 0 1 8 0q.834 0 1.417.583.583.584.583 1.425 0 .825-.583 1.409A1.94 1.94 0 0 1 7.992 4M8 2.8a.77.77 0 0 0 .57-.23A.77.77 0 0 0 8.8 2a.77.77 0 0 0-.23-.57A.77.77 0 0 0 8 1.2a.77.77 0 0 0-.57.23.77.77 0 0 0-.23.57q0 .34.23.57T8 2.8"
    />
  </svg>
);
export default SvgGroups;
